import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card, Input, LineChart } from '@node-space/ui-components'
import { RewardsProduct } from 'types/rewards'
import { useCalculateRewards } from '../hooks/useCalculateRewards'
import { useChartProps } from '../hooks/useChartProps'
import { useRewardsForm } from '../hooks/useRewardsForm'
import { RewardsCryptoSelect } from './RewardsCryptoSelect'

interface RewardCompoundedCalculatorProps {
  rewardsProducts: RewardsProduct[]
}

export const RewardCompoundedCalculator = ({
  rewardsProducts,
}: RewardCompoundedCalculatorProps) => {
  const { t } = useTranslation()
  const { amount, selectedCurrency, register, onAmountChange, onCurrencyChange } = useRewardsForm()
  const { rewardsData } = useCalculateRewards(amount, selectedCurrency)
  const chartProps = useChartProps(rewardsData)

  return (
    <Card variant="static" full>
      <Box flexCol gapY={24}>
        <h2 className="text-h4 text-foreground-prominent">
          {t('rewards.expectedRewardsDescription')}
        </h2>

        <Box className="grid grid-cols-1 lg:grid-cols-[255px_255px_auto] gap-4">
          <RewardsCryptoSelect
            rewardsProducts={rewardsProducts}
            currency={selectedCurrency}
            onChange={onCurrencyChange}
          />

          <Input
            {...register('amount')}
            label="Amount"
            placeholder="Enter amount"
            inputMode="numeric"
            defaultValue={amount}
            onChange={onAmountChange}
          />
        </Box>

        <Box className="mt-2">
          <LineChart {...chartProps} />
        </Box>
      </Box>
    </Card>
  )
}
